import { React, useEffect, useState } from 'react'
import { CFormTextarea, CCard, CButton, CSpinner, CBadge, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CNav, CNavItem, CNavLink, CTabContent, CTabPane, CCardBody } from '@coreui/react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import InternalNotesCRUD from '../../services/general/internalNotesAPI.api'
import Carder from '../../components/shared/Carder'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import Graytextarea from '../../components/Graytextarea'
import { Calendar } from 'lucide-react'

const ProviderInternalNotes = ({ patientID, loading, setLoading, saveTreatsShell, noteStructureRef }) => {
  const [Notes, setNotes] = useState([])
  const [diagnosisData, setDiagnosisData] = useState([])
  const [textInput, setTextInput] = useState('')
  const [modalVisible, setModalVisible] = useState(false)
  const [activeTab, setActiveTab] = useState('new')
  const [currentDate, setCurrentDate] = useState('')
  const [noteEditId, setNotesEditId] = useState(null)
  const [loadings, setLoadings] = useState(false)
  const [editNote, setEditNote] = useState(null)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [editableInternalNote, setEditableInternalNote] = useState('')

  const editNotes = (note, tooChangeTab = true) => {
    setEditNote(note)
    setNotesEditId(note.Id)
    setModalVisible(true)
    setTextInput(note.InternalNotes)
    if (tooChangeTab) {
      setActiveTab('new')
    }
  }

  const handlePopulatingSameMetadataHisotry = () => {
    const internalNoteId = noteStructureRef.current?.metadata?.internalNoteId
    if (internalNoteId) {
      setEditableInternalNote(internalNoteId)
      const findSingleCurrentNoteAlwaysEditForThisNoteCreated = Notes.find((item) => item.Id === internalNoteId)
      if (findSingleCurrentNoteAlwaysEditForThisNoteCreated) {
        editNotes(findSingleCurrentNoteAlwaysEditForThisNoteCreated, false)
      }
    }
  }
  const addNote = async () => {
    if (!textInput.trim()) {
      toast.error('Please enter the note text', toastConfig)
      return
    }
    setLoadings(true)
    try {
      if (editNote !== null) {
        let allData = await InternalNotesCRUD('UPDATE', patientID.toString(), textInput, currentDate, noteEditId)
        await getPatientInternalNotes()

        // setTextInput("")
        // setActiveTab("old")
        // setEditNote(null)
        // setNotesEditId(null)
        setLoadings(false)
        toast.success('Successfully Updated', toastConfig)
      } else {
        let allData = await InternalNotesCRUD('INSERT', patientID, textInput, currentDate)
        let history = JSON.parse(allData.d)
        const allNotess = await getPatientInternalNotes()
        let latestNoteId = null
        if (allNotess.length > 0) {
          latestNoteId = allNotess[0]?.Id

          noteStructureRef.current = {
            ...noteStructureRef.current,
            metadata: {
              ...noteStructureRef.current.metadata,
              internalNoteId: latestNoteId,
            },
          }
          setEditableInternalNote(latestNoteId)

          // Save the shell (passing false as an argument)
          await saveTreatsShell(false)

          // setTextInput("")
          // setActiveTab("old")
          setEditNote(textInput)
          setNotesEditId(latestNoteId ? latestNoteId : null)
          setLoadings(false)
          toast.success('Successfully Added', toastConfig)
          handlePopulatingSameMetadataHisotry()
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  const getPatientInternalNotes = async () => {
    let allData = await InternalNotesCRUD('GET', patientID)
    let history = JSON.parse(allData?.d)
    // let sortedNotes = history?.Data?.sort((a, b) => new Date(b.Date) - new Date(a.Date));
    let sortedNotes = history?.Data?.sort((a, b) => new Date(b.Id) - new Date(a.Id))
    setNotes(sortedNotes)
    return sortedNotes
  }

  useEffect(() => {
    // getDiagnosisData();
    getPatientInternalNotes()
    setCurrentDate(getFormattedDate())
  }, [patientID])

  const handleInputChange = (event) => {
    setTextInput(event.target.value)
  }

  const getFormattedDate = () => {
    const today = new Date()
    const dd = String(today.getDate()).padStart(2, '0')
    const mm = String(today.getMonth() + 1).padStart(2, '0') // January is 0!
    const yyyy = today.getFullYear()
    return `${mm}.${dd}.${yyyy}`
  }
  const handleDeleteInternalNotes = async () => {
    await InternalNotesCRUD('DELETE', '', '', '', deleteVisibleId?.toString())
    await getPatientInternalNotes()
    setDeleteVisibleId(null)
    setEditNote(null)
    setTextInput('')
    setNotesEditId(null)
  }
  useEffect(() => {
    handlePopulatingSameMetadataHisotry()
  }, [Notes, activeTab])

  return (
    <>
      {/* delete modal */}
      <CModal visible={deleteVisibleId}>
        <CModalHeader>
          <CModalTitle>Warning</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
        </CModalBody>
        <hr className="p-0 m-0" />
        <CModalFooter className="p-3 m-0">
          <CButton
            onClick={() => {
              setDeleteVisibleId(null)
            }}
            className="text-white"
            color="secondary"
          >
            Close
          </CButton>
          <CButton onClick={handleDeleteInternalNotes} className="text-white" color="danger">
            Delete
          </CButton>
        </CModalFooter>
      </CModal>
      <div>
        <CNav variant="pills" className="justify-content-center">
          <CNavItem>
            <CNavLink active={activeTab === 'new'} onClick={() => setActiveTab('new')}>
              New
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink active={activeTab === 'old'} onClick={() => setActiveTab('old')}>
              Existing
            </CNavLink>
          </CNavItem>
        </CNav>
        <CTabContent>
          <CTabPane visible={activeTab === 'new'} className="mt-4">
            {loading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ height: '100px' }}>
                <CSpinner color="primary" />
              </div>
            ) : (
              <>
                {/* <div className="mb-3">Date : {currentDate}</div>  */}

                <Graytextarea type="text" id="textInput" value={textInput} rows={3} onChange={handleInputChange} />

                <CButton style={{ marginTop: '10px' }} onClick={addNote} variant="outline" color="primary" className="patient-page-action-btn">
                  {loadings ? (
                    <CSpinner component="span" size="sm" aria-hidden="true" />
                  ) : (
                    <>{noteEditId !== null ? 'Update' : 'Add'}</>
                  )}
                </CButton>
              </>
            )}
          </CTabPane>
          <CTabPane visible={activeTab === 'old'}>
            {Notes.map((obj) => {
              return (
                <>
                  <Carder
                    deleteFunc={
                      editableInternalNote === obj.Id
                        ? () => {
                            setDeleteVisibleId(obj.Id)
                          }
                        : null
                    }
                    editFunc={
                      editableInternalNote === obj.Id
                        ? () => {
                            editNotes(obj)
                          }
                        : null
                    }
                    style={{ borderRadius: '1rem', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)' }}
                    className="mt-3"
                  >
                    <CCardBody>
                      <p style={{ whiteSpace: 'pre-line' }}>
                        <div className="mb-3 d-flex align-items-center gap-2">
                          <Calendar size={15} />
                          <p className="m-0 p-0">{new Date(obj.Date).toLocaleDateString('en-US')}</p>
                        </div>
                        <div className="mb-3">
                          <strong>Note:</strong> {obj.InternalNotes}
                        </div>
                      </p>
                    </CCardBody>
                  </Carder>
                </>
              )
            })}
          </CTabPane>
        </CTabContent>
      </div>
    </>
  )
}

export default ProviderInternalNotes
